var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_vm._m(0),_c('div',{staticClass:"copyright text-center"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"#","target":"_blank"}},[_vm._v("Roughton International Project Team")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Licenses")])])])])
}]

export { render, staticRenderFns }